module.exports = __webpack_public_path__ + "static/media/view2.9863a97b.jpg";